// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"79":"24272e2a6654cce4d0be","661":"a591abb00eee0cb148e6","702":"c9aad0c71ae5acdae358"}[chunkId] + ".bundle.js";
};